import React, { SVGProps } from 'react';

const DotMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_3802_12920"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3802_12920)">
      <path
        d="M5.19234 11.25C4.84861 11.25 4.55434 11.1276 4.30955 10.8828C4.06477 10.638 3.94238 10.3437 3.94238 9.99999C3.94238 9.65626 4.06477 9.36199 4.30955 9.1172C4.55434 8.87241 4.84861 8.75002 5.19234 8.75002C5.53609 8.75002 5.83036 8.87241 6.07513 9.1172C6.31992 9.36199 6.44232 9.65626 6.44232 9.99999C6.44232 10.3437 6.31992 10.638 6.07513 10.8828C5.83036 11.1276 5.53609 11.25 5.19234 11.25ZM10 11.25C9.65629 11.25 9.36203 11.1276 9.11724 10.8828C8.87245 10.638 8.75005 10.3437 8.75005 9.99999C8.75005 9.65626 8.87245 9.36199 9.11724 9.1172C9.36203 8.87241 9.65629 8.75002 10 8.75002C10.3438 8.75002 10.638 8.87241 10.8828 9.1172C11.1276 9.36199 11.25 9.65626 11.25 9.99999C11.25 10.3437 11.1276 10.638 10.8828 10.8828C10.638 11.1276 10.3438 11.25 10 11.25ZM14.8077 11.25C14.464 11.25 14.1697 11.1276 13.9249 10.8828C13.6801 10.638 13.5577 10.3437 13.5577 9.99999C13.5577 9.65626 13.6801 9.36199 13.9249 9.1172C14.1697 8.87241 14.464 8.75002 14.8077 8.75002C15.1515 8.75002 15.4457 8.87241 15.6905 9.1172C15.9353 9.36199 16.0577 9.65626 16.0577 9.99999C16.0577 10.3437 15.9353 10.638 15.6905 10.8828C15.4457 11.1276 15.1515 11.25 14.8077 11.25Z"
        fill="#596180"
      />
    </g>
  </svg>
);

export default DotMenu;
